import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import mill from "./modules/mill";
import device from "./modules/device";
import chart from "./modules/chart";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState()],
  modules: {
    auth,
    mill,
    device,
    chart,
  },
  state: {
    /* Button Loading */
    btnLoading: false,
    /* Content Loading */
    contentLoading: false,
    /* Data Loading */
    dataLoading: false,
    /* Error */
    error: "",
    /* Status */
    status: "",
  },
  mutations: {
    setBtnLoading(state, payload) {
      state.btnLoading = payload;
    },

    setContentLoading(state, payload) {
      state.contentLoading = payload;
    },

    setDataLoading(state, payload) {
      state.dataLoading = payload;
    },

    setError(state, payload) {
      state.error = payload;
    },

    setStatus(state, payload) {
      state.status = payload;
    },
  },
  actions: {
    setError: (context, errorMsg) => {
      context.commit("setError", errorMsg);
    },

    setStatus: (context, statusMsg) => {
      context.commit("setStatus", statusMsg);
    },
  },
  getters: {
    error(state) {
      return state.error;
    },
    status(state) {
      return state.status;
    },
  },
});
